import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { TextAPI } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import BaseController from '../BaseController';
import './index.css';

@Controller({ fragment: 'modal-active', component: 'layout-active' })
export default class ModalActiveController extends BaseController {

  @Inject('text-description')
  description: TextAPI;

  @OnMount({ target: 'layout-active' })
  OnOpenModal(): void {
    const context = this.context.get('situationActual') as string;
    this.description.setValue(context == 'I' ? MessageService.translate('results.active.user'): MessageService.translate('results.deactivate'));
  }

}